// extracted by mini-css-extract-plugin
export default {"context__menu":"MessageContextMenu_context__menu__jfbwI","modal":"MessageContextMenu_modal__z9lv6","context__menu-item":"MessageContextMenu_context__menu-item__8GM5y"};